import { map } from "lodash";
import moment from "moment";
import { Select } from "PFComponents/select/select";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./schedule_settings_modal.module.scss";
import { useWeekdayLabel } from "./use_weekday_label";

export enum MonthlyInterval {
  Day = "day",
  Weekday = "weekday"
}

type MonthlySelectorProps = {
  value: string | null;
  onChange: (value: string) => void;
};

export const MonthlySelector = ({ value, onChange }: MonthlySelectorProps): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.exportWizard" });

  const weekday = useWeekdayLabel();

  const optionsMap = useMemo(
    () => ({
      [MonthlyInterval.Day]: t("monthlySelectorDayOption", { day: moment().format("DD") }),
      [MonthlyInterval.Weekday]: t("monthlySelectorWeekdayOption", { weekday })
    }),
    [weekday, t]
  );
  const options = useMemo(
    () => map(optionsMap, (label, key) => ({ id: key, item: key, displayElement: label })),
    [optionsMap]
  );

  return (
    <Select
      // @ts-ignore
      className={css.monthlySelector}
      options={options}
      handleChange={onChange}
      value={optionsMap[value || MonthlyInterval.Day]}
      controlledValue
    />
  );
};
